import { useState, useEffect } from 'react';

import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalFooter,
} from '@grupoboticario/flora-react';

import { ModalText, ButtonFooter } from './styles';

interface IModalError {
  deleteFile: any;
  setIsOpen: any;
  isOpen: boolean;
  file: any;
  status: number;
  setStatus: any;
}

export const ModalDeleteUploadedFile = (props: IModalError): JSX.Element => {
  const { setIsOpen, isOpen, deleteFile, file, status, setStatus } = props;

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    if (!loading) {
      setStatus(1);
      setIsOpen(false);
    }
  };

  const onClickDeleteFile = () => {
    if (!loading) {
      deleteFile(file);
      setLoading(true);
    }
  };

  useEffect(() => {
    if (status === 0) {
      // reset
      setStatus(1);
      setLoading(false);
    }
    if (status === 2) {
      setLoading(false);
    }
  }, [status]);

  return (
    <Modal open={isOpen} onOpenChange={closeModal}>
      <ModalContent size="small">
        <ModalCloseButton />
        <ModalHeader />
        {status === 1 && (
          <>
            <ModalBody>
              <ModalText>Deseja excluir este documento?</ModalText>
            </ModalBody>
            <ButtonFooter>
              <Button
                size="small"
                styleSemantic="warning"
                type="button"
                onClick={() => onClickDeleteFile()}
              >
                Sim
              </Button>
              <Button size="small" type="button" onClick={() => closeModal()}>
                Não
              </Button>
            </ButtonFooter>
          </>
        )}
        {status === 2 && (
          <>
            <ModalBody>
              <ModalText>Erro: não foi possível excluir este arquivo</ModalText>
            </ModalBody>
            <ButtonFooter>
              <Button size="small" type="button" onClick={() => closeModal()}>
                Ok
              </Button>
            </ButtonFooter>
          </>
        )}

        <ModalFooter />
      </ModalContent>
    </Modal>
  );
};
